export class Currency {
    constructor(
      public currency: string,
      public currencyFullName: string
    ) { }
  }